import style from 'containers/MyHealth/components/MyHealthResultsContext/styles'
import { MINIMUM_FONT_SIZE } from 'styles/typography'

export const styles = {
  ...style,
  fieldName: {
    fontWeight: 700,
    fontSize: 14,
    textWrap: 'wrap'
  },
  medicationFieldName: {
    fontWeight: 700,
    fontSize: 14,
    textWrap: 'wrap',
    marginLeft: 16
  },
  medicationName: {
    paddingLeft: 16,
    overflowWrap: 'break-word'
  },
  headerRow: {
    marginBottom: 15
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    background: '#DEE8F6',
    height: 36
  },
  medicationUppercase: {
    fontSize: MINIMUM_FONT_SIZE,
    fontWeight: 700,
    textTransform: 'uppercase',
    textWrap: 'wrap'
  },
  noPadding: {
    padding: 0
  },
  noPaddingTop: {
    paddingTop: 0,
    marginTop: '-0.5rem'
  },
  printLayout: {
    position: 'relative',
    background: '#FFFFFF',
    height: 1050
  },
  printLayoutSafari: {
    position: 'relative',
    background: '#FFFFFF',
    height: 880
  },
  printLayoutInIos: {
    position: 'relative',
    background: '#FFFFFF',
    height: 900
  },
  printLayoutHeader: {
    minHeight: 225,
    padding: 0,
    background: 'none'
  },
  printLayoutCommonHeader: {
    minHeight: 125,
    padding: 0,
    background: 'none'
  },
  printLayoutContent: {
    height: 'calc(100% - 390px)',
    padding: 0,
    overflow: 'hidden'
  },
  printLayoutFooter: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    minHeight: 160,
    padding: 0,
    background: 'none'
  },
  printContainer: {
    width: 715,
    paddingTop: 30,
    height: 0,
    overflow: 'hidden'
  },
  printerIcon: {
    transform: 'scaleX(-1)'
  },
  medicationPrintItem: {
    overflow: 'hidden'
  },
  fieldNameNoWrap: {
    whiteSpace: 'nowrap'
  }
}

export const themeStyles = colors => {
  const downLoadButton = {
    color: colors.white,
    backgroundColor: colors.primary,
    textTransform: 'uppercase',
    lineHeight: 'revert',
    borderRadius: 25
  }
  return { downLoadButton }
}

